import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../../data/content";
import { Reveal, Eyebrow } from "../motion";

export const Positioning = () => {
  const navigate = useNavigate();
  return (
    <section className="py-24 lg:py-36" data-testid="section-positionnement">
      <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow>Notre positionnement</Eyebrow>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-serif text-4xl leading-[1.08] text-cream sm:text-5xl lg:text-6xl">
                L'immobilier traditionnel n'est pas notre terrain de jeu.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <Reveal delay={0.15}>
              <p className="text-lg leading-relaxed text-white/75">Acheter un bien ne suffit plus.</p>
            </Reveal>
            <Reveal delay={0.22}>
              <p className="mt-6 leading-relaxed text-white/55">
                Pour créer de la valeur, il faut savoir identifier une opportunité, imaginer un concept différenciant
                et transformer un simple bien immobilier en une véritable expérience.
              </p>
            </Reveal>
            <Reveal delay={0.28}>
              <p className="mt-6 leading-relaxed text-white/55">
                Suites romantiques, hébergements familiaux à thème, logements gaming ou cinéma, refuges nature
                déconnectés, lieux de séminaire « work & fun »... Chez Demoiselle Atypique, nous accompagnons nos
                clients pour construire des projets qui ne ressemblent pas aux autres.
              </p>
            </Reveal>
            <Reveal delay={0.34}>
              <button onClick={() => navigate("/rendez-vous")} data-testid="positioning-cta" className="btn-primary mt-10">
                J'ai un projet <ArrowRight className="h-4 w-4" />
              </button>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1} className="mt-16">
          <div className="group relative aspect-[16/9] overflow-hidden lg:aspect-[21/9]">
            <img
              src={IMAGES.positionnement}
              alt="Love room atypique avec billard, néons et espace de jeu — expérience immobilière immersive créée par Demoiselle Atypique"
              className="h-full w-full object-cover transition-transform duration-[1.4s] group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/60 to-transparent" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
